import React from "react";

interface SpecialtyProps {
  label: string;
  className?: string;
}

export const Specialty: React.FC<SpecialtyProps> = ({
  label,
  className = "",
}) => {
  return (
    <span
      className={`inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-800 border border-primary-200 ${className}`}
    >
      {label}
    </span>
  );
};

